import { render, staticRenderFns } from "./gongju.vue?vue&type=template&id=57970de6&scoped=true&"
import script from "./gongju.vue?vue&type=script&lang=js&"
export * from "./gongju.vue?vue&type=script&lang=js&"
import style0 from "./gongju.vue?vue&type=style&index=0&id=57970de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57970de6",
  null
  
)

export default component.exports